import React, { useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import Link from "@amzn/meridian/esm/components/link";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import sparklesIcon from "../../images/sparkles_small.svg";

const STORAGE_KEY = "aims_verbosity_banner_dismissed";

/**
 * Discovery banner nudging users to set their summary detail level in Settings.
 * Matches the existing "started by" banner pattern (teal border Box with dismiss).
 * Dismissible via sessionStorage (won't reappear during same session).
 *
 * @param {function} onSettingsClick - Callback to navigate to Settings tab
 */
const VerbosityDiscoveryBanner = ({ onSettingsClick }) => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === "true"
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "true");
    setDismissed(true);
  };

  return (
    <Row alignmentHorizontal="center" spacing="none">
      <div style={{ position: "relative" }}>
        <Theme tokens={{ boxBorderColorOutline: "#AFE8D7" }}>
          <Box type="outline" width="322px" spacingInset="400">
            <Row spacing="300" alignmentVertical="center">
              <img src={sparklesIcon} alt="" width="16" height="16" />
              <Text type="b200">
                Set summary detail level in <Link type="primary" onClick={onSettingsClick}>Settings</Link>
              </Text>
            </Row>
          </Box>
        </Theme>
        <div style={{ position: "absolute", top: "2px", right: "2px" }}>
          <Button type="icon" size="small" onClick={handleDismiss}>
            <Icon tokens={closeSmallTokens} color="#575F67">Close</Icon>
          </Button>
        </div>
      </div>
    </Row>
  );
};

export default VerbosityDiscoveryBanner;
